module.exports = __webpack_public_path__ + "img/hot_rlqd.943fd7ed.png";